import React from 'react';
import { Link } from 'react-router-dom';
import { ChevronRight } from 'lucide-react';

const CFG = {
  pending: { label: 'Pending', cls: 'bg-slate-100 text-slate-600 dark:bg-slate-700 dark:text-slate-300' },
  present: { label: 'Present', cls: 'bg-emerald-100 text-emerald-700 dark:bg-emerald-900/30 dark:text-emerald-300' },
  absent: { label: 'Absent', cls: 'bg-rose-100 text-rose-700 dark:bg-rose-900/30 dark:text-rose-300' },
};

// Student-facing state of an offline (paper) test: no Start, no exam window.
export function PaperTestBadge({ exam }) {
  const status = exam.paper_status || 'pending';
  const cfg = CFG[status] || CFG.pending;
  return (
    <>
      <span className="rounded-full bg-violet-100 px-2.5 py-0.5 text-xs font-semibold text-violet-700 dark:bg-violet-900/30 dark:text-violet-300">
        Paper test
      </span>
      <span className={`rounded-full px-2.5 py-0.5 text-xs font-semibold ${cfg.cls}`}>
        {cfg.label}
        {status === 'present' && exam.paper_score != null ? ` (${exam.paper_score}/${exam.total_marks})` : ''}
      </span>
    </>
  );
}

export function PaperTestAction({ exam }) {
  if (exam.paper_status === 'present' && exam.attempt_id) {
    return (
      <Link
        to={`/student/results/${exam.attempt_id}`}
        className="flex items-center gap-1 whitespace-nowrap rounded-lg border border-slate-300 px-4 py-2 text-sm font-medium text-slate-700 transition-colors hover:bg-slate-50 dark:border-slate-600 dark:text-slate-300 dark:hover:bg-slate-700"
      >
        View Result <ChevronRight size={15} />
      </Link>
    );
  }
  return (
    <span className="whitespace-nowrap text-sm text-slate-500 dark:text-slate-400">
      {exam.paper_status === 'absent' ? 'Marked absent' : 'Result awaited'}
    </span>
  );
}
